/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Reports charts
import ASNStatusPieChart from "layouts/dashboard/reports/ApprovedvsPendingChart";
import ASNMonthlyChart from "layouts/dashboard/reports/ASNMonthlyChart";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { Card } from "@mui/material";

// Soft UI Dashboard React components
import SoftBox from "components/MDBox";
import SoftTypography from "components/MDTypography";
import {
  EventAvailable,
  Inventory,
  LocalShipping,
  PriorityHigh,
  ShoppingCart,
  ViewQuilt,
} from "@mui/icons-material";
import DashboardController from "Controller/DashboardController";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const { dashboardData } = DashboardController();

  console.log(dashboardData);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card sx={{ height: "100%" }}>
            <SoftBox
              sx={{
                height: "200px", // or any height you want
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SoftTypography variant="h6" fontWeight="medium">
                No data yet!
              </SoftTypography>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox> */}

      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon={<Inventory />}
                title="Total PO"
                count={dashboardData[0]?.totalPOCount ?? 0}
                // url="/vendor-po"
                // percentage={{
                //   color: "success",
                //   amount: "+55%",
                //   label: "than lask week",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon={<ShoppingCart />}
                title="Ordered Quantity"
                count={dashboardData[0]?.totalOrderedQty ?? 0}
                // url="/grn-status"
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="widgets"
                title="Total Quantity"
                count={dashboardData[0]?.totalOrderedQty ?? 0}
                // url="/grn-status"
                // percentage={{
                //   color: "success",
                //   amount: "+3%",
                //   label: "than last month",
                // }}
              />
            </MDBox>
          </Grid> */}
          {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon={<LocalShipping />}
                title="Dispatch Quantity"
                count={dashboardData[0]?.totalDispatchedQty ?? 0}
                // url="/grn-status"
                // percentage={{
                //   color: "success",
                //   amount: "+1%",
                //   label: "than yesterday",
                // }}
              />
            </MDBox>
          </Grid> */}
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon={<ViewQuilt />}
                title="Balance Quantity"
                count={dashboardData[0]?.totalBalancedQty ?? 0}
                // url="/grn-status"
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="done"
                title="Accepted ASN"
                count={dashboardData[0]?.totalASNApproved ?? 0}
                // url="/asn-status"
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon={<PriorityHigh />}
                title="Pending ASN"
                count={dashboardData[0]?.totalASNPending ?? 0}
                // url="/asn-status"
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon={<EventAvailable />}
                title="Appointments"
                count={dashboardData[0]?.appointments ?? 0}
                url="/appointments"
              />
            </MDBox>
          </Grid>
        </Grid>

        {/* <MDBox mt={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AppointmentCalendarCard appointments={appointmentData} />
            </Grid>
          </Grid>
        </MDBox> */}
        {/* <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <Card sx={{ padding: 2 }}>
                  <SoftTypography mb={1} variant="h6" fontWeight="medium">
                    ASN Status Overview
                  </SoftTypography>

                  <ASNStatusPieChart
                    approved={dashboardData[0]?.totalASNApproved ?? 0}
                    pending={dashboardData[0]?.totalASNPending ?? 0}
                  />
                </Card>
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={8}>
              <MDBox mb={3}>
                <Card sx={{ padding: 2 }}>
                  <SoftTypography mb={1} variant="h6" fontWeight="medium">
                    Monthly ASN Orders (Past FY)
                  </SoftTypography>

                  <ASNMonthlyChart
                    monthlyData={
                      dashboardData[0]?.monthlyASN ?? [
                        120, 180, 150, 200, 230, 210, 250, 240, 260, 230, 220, 300,
                      ]
                    }
                  />
                </Card>
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox> */}
        {/* <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox> */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
